import { useContext } from 'react';

// auth provider
import { EventsContext } from 'contexts/EventsContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/AWSCognitoContext';

// ==============================|| AUTH HOOKS ||============================== //

const useEvents = () => {
    const context = useContext(EventsContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useEvents;
